<div class="d-flex justify-content-between">
  <h2 *ngIf="title && !hideTitle">{{ title }}</h2>
  <div>
    <ng-content select="[actionsButton]"></ng-content>
  </div>
</div>
<div class="custom-list-container">

  <div class="custom-list-tabs" *ngIf="!hideTabs">
    <ng-content select="[tabs]"></ng-content>
  </div>

  <div class="custom-list-filters filters-content" *ngIf="!hideFilters">
    <ng-content select="[filters]"></ng-content>
  </div>

  <div class="custom-list-infos" *ngIf="!hideInfos">
    <ng-content select="[infos]"></ng-content>
  </div>

  <div class="custom-list-options">
    <div class="d-flex justify-content-end">
      <div class="action-buttons d-flex align-items-center">
        <button *ngIf="buttonsConfig?.sendReminder?.show"
            nbButton
            type="button"
            size="small"
            status="primary"
            (click)="buttonsConfig?.sendReminder?.customAction ? buttonsConfig?.sendReminder?.customAction() : null">
          <nb-icon icon="bell">
          </nb-icon>
          {{'admin.modules.recruitment.grid.actions.send_reminder' | translate}}
          <span *ngIf="buttonsConfig?.sendReminder?.lastSendDate" class="ml-2">
            ({{buttonsConfig?.sendReminder?.lastSendDate | momentPipe: 'DD/MM/YYYY'}})
          </span>
        </button>

        <pv-dropdown-action-button
          *ngIf="buttonsConfig?.dropdown?.show"
          [disabled]="buttonsConfig?.dropdown?.isLoading"
          [loading]="buttonsConfig?.dropdown?.isLoading"
          [icon]="'download'"
          [label]="'shared.components.custom_list_layout.export_all' | translate"
          [menuItems]="buttonsConfig?.dropdown?.menuItems"
          [contextMenuTag]="'custom-list-dropdown-' + storageKey"
          (menuItemClick)="onDropdownMenuItemClicked($event)">
        </pv-dropdown-action-button>

        <pv-action-button
          *ngIf="buttonsConfig?.import?.show"
          [disabled]="buttonsConfig?.import?.isLoading"
          [loading]="buttonsConfig?.import?.isLoading"
          [label]="'shared.components.custom_list_layout.import' | translate"
          [icon]="'upload'"
          (click)="onImportClicked()">
        </pv-action-button>

        <pv-action-button
          *ngIf="buttonsConfig?.exportAll?.show"
          [disabled]="buttonsConfig?.exportAll?.isLoading"
          [loading]="buttonsConfig?.exportAll?.isLoading"
          [label]="'shared.components.custom_list_layout.export_all' | translate"
          [icon]="'download'"
          (click)="onExportAllClicked()">
        </pv-action-button>

        <pv-action-button
          *ngIf="buttonsConfig?.export?.show"
          [disabled]="buttonsConfig?.export?.isLoading"
          [loading]="buttonsConfig?.export?.isLoading"
          [icon]="'download'"
          (click)="onExportClicked()">
        </pv-action-button>

        <pv-action-button
          *ngIf="buttonsConfig?.refresh?.show"
          [disabled]="buttonsConfig?.refresh?.isLoading"
          [loading]="buttonsConfig?.refresh?.isLoading"
          [label]="'shared.components.custom_list_layout.refresh' | translate"
          [icon]="'sync'"
          (click)="onRefreshClicked()">
        </pv-action-button>

        <pv-column-settings
          [columns]="columnSettings"
          [storageKey]="storageKey"
          (visibilityChanged)="onColumnVisibilityChanged($event)"
          *ngIf="showColumnSettings">
        </pv-column-settings>

        <pv-filter-settings
          [filters]="filterSettings"
          [storageKey]="storageKey"
          (visibilityChanged)="onFilterVisibilityChanged($event)"
          *ngIf="showFilterSettings">
        </pv-filter-settings>
      </div>
    </div>
  </div>

  <div class="custom-list-content">
    <ng-content select="[content]"></ng-content>
  </div>
</div>
